import { get } from 'lodash'
// import moment from 'moment'

export default function () {
  this.getTowersDweller()

  /** Unidade Selecionada */
  if (get(this.$route, 'params.tower_id', null) !== null) {
    this.selectUnitsTower(get(this.$route, 'params.tower_id', null))
  }
  /** Garagens */
  if (get(this.$route, 'params.unit_id', null) !== null) {
    this.getGaragesDwellerEdit(get(this.$route, 'params.unit_id', null), get(this.$route, 'params.tower_id', null))
  }

  // const gotInOut = moment(this.moving.go_in_out, 'YYYYMMDD').format('YYYY-MM-DD')
  // console.log(moment(new Date(), 'YYYYMMDD').format('YYYY-MM-DD'))
  // const isBefore = moment(gotInOut).isAfter(moment(new Date(), 'YYYYMMDD').format('YYYY-MM-DD'))
  // console.log(this.moving)
  // if (isBefore) {
  //   this.lockGoInOut = true
  // }
}



// WEBPACK FOOTER //
// ./src/app/dweller/moving/form/resources/mounted.js